(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-subscribe-form-v1"] && !Shopify.designMode) return;
  try {
    
  class YGSubscribeFormV1 extends HTMLElement {
    constructor() {
      super();
      this.handleConsentChange = this.handleConsentChange.bind(this);
      this.handleEmailInput = this.handleEmailInput.bind(this);
      this.handleEmailInvalid = this.handleEmailInvalid.bind(this);
      this.handleSubmitButtonClick = this.handleSubmitButtonClick.bind(this);
      this.handlePageShow = this.handlePageShow.bind(this);
      this.handlePageHide = this.handlePageHide.bind(this);
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    connectedCallback() {
      if (this.isInitialized) {
        return;
      }

      this.isInitialized = true;
      this.$form = this.querySelector('.yg-subscribe-form-v1__form');
      this.$consents = Array.from(this.querySelectorAll('.yg-subscribe-form-v1__checkbox'));
      this.$submitButton = this.querySelector('.yg-subscribe-form-v1__submit');
      this.$emailInput = this.querySelector('.yg-subscribe-form-v1__email');
      this.$duplicateMessage = this.querySelector('.yg-subscribe-form-v1__duplicate-message');
      this.$invalidEmailMessage = this.querySelector('.yg-subscribe-form-v1__invalid-email-message');
      this.$requiredEmailMessage = this.querySelector('.yg-subscribe-form-v1__required-email-message');
      this.isSubmitPending = false;
      this.storageKey = this.dataset.storageKey;
      this.pendingEmailStorageKey = `${this.storageKey}-pending`;

      this.$consents.forEach(($consent) => {
        $consent.addEventListener('change', this.handleConsentChange);
      });
      this.$form?.addEventListener('submit', this.handleFormSubmit, true);
      this.$emailInput?.addEventListener('input', this.handleEmailInput);
      this.$emailInput?.addEventListener('invalid', this.handleEmailInvalid);
      this.$submitButton?.addEventListener('click', this.handleSubmitButtonClick);
      window.addEventListener('pageshow', this.handlePageShow);
      window.addEventListener('pagehide', this.handlePageHide);
      this.updateSubmitButton();
      this.recordSuccessfulEmail();
    }

    disconnectedCallback() {
      this.$consents?.forEach(($consent) => {
        $consent.removeEventListener('change', this.handleConsentChange);
      });
      this.$form?.removeEventListener('submit', this.handleFormSubmit, true);
      this.$emailInput?.removeEventListener('input', this.handleEmailInput);
      this.$emailInput?.removeEventListener('invalid', this.handleEmailInvalid);
      this.$submitButton?.removeEventListener('click', this.handleSubmitButtonClick);
      window.removeEventListener('pageshow', this.handlePageShow);
      window.removeEventListener('pagehide', this.handlePageHide);
      this.clearSubmitLoadingTimers();
      this.isInitialized = false;
    }

    handleConsentChange(event) {
      const $checkboxWrap = event.target.closest('.yg-subscribe-form-v1__checkbox-wrap');
      if (event.target.checked && $checkboxWrap) {
        $checkboxWrap.dataset.invalid = 'false';
      }
      this.updateSubmitButton();
    }

    handleEmailInput() {
      this.hideDuplicateMessage();
      this.hideInvalidEmailMessage();
      this.hideRequiredEmailMessage();
    }

    handleEmailInvalid(event) {
      event.preventDefault();
      if (this.getNormalizedEmail() === '') {
        this.showRequiredEmailMessage();
        return;
      }

      this.showInvalidEmailMessage();
    }

    handleSubmitButtonClick() {
      if (!this.hasAcceptedAllConsents()) {
        this.showConsentErrors();
      }
    }

    handlePageShow() {
      this.setSubmitLoading(false);
    }

    handlePageHide() {
      this.clearSubmitLoadingTimers();
    }

    handleFormSubmit(event) {
      if (this.isSubmitting || this.isSubmitPending) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      if (!this.hasAcceptedAllConsents()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.showConsentErrors();
        this.$consents.find(($consent) => !$consent.checked)?.focus();
        return;
      }

      const email = this.getNormalizedEmail();
      if (!this.isValidEmail(email)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.showInvalidEmailMessage();
        this.$emailInput?.focus();
        return;
      }

      if (this.hasStoredEmail(email)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.showDuplicateMessage();
        this.$emailInput?.focus();
        return;
      }

      if (email) {
        this.setPendingEmail(email);
      }

      this.queueSubmitLoading(event);
    }

    hasAcceptedAllConsents() {
      return this.$consents.length > 0 && this.$consents.every(($consent) => $consent.checked);
    }

    showConsentErrors() {
      this.$consents.forEach(($consent) => {
        const $checkboxWrap = $consent.closest('.yg-subscribe-form-v1__checkbox-wrap');
        if ($checkboxWrap) {
          $checkboxWrap.dataset.invalid = String(!$consent.checked);
        }
      });
    }

    getNormalizedEmail() {
      return this.$emailInput?.value.trim().toLowerCase() || '';
    }

    isValidEmail(email) {
      const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
      return emailPattern.test(email);
    }

    getStoredEmails() {
      try {
        const storedEmails = JSON.parse(window.localStorage.getItem(this.storageKey) || '[]');
        return Array.isArray(storedEmails) ? storedEmails : [];
      } catch (error) {
        return [];
      }
    }

    hasStoredEmail(email) {
      return email !== '' && this.getStoredEmails().includes(email);
    }

    setPendingEmail(email) {
      try {
        window.sessionStorage.setItem(this.pendingEmailStorageKey, email);
      } catch (error) {
        return;
      }
    }

    recordSuccessfulEmail() {
      if (!this.querySelector('.yg-subscribe-form-v1__success-marker')) {
        return;
      }

      try {
        const email = window.sessionStorage.getItem(this.pendingEmailStorageKey);
        if (email && !this.hasStoredEmail(email)) {
          window.localStorage.setItem(this.storageKey, JSON.stringify([...this.getStoredEmails(), email]));
        }
        window.sessionStorage.removeItem(this.pendingEmailStorageKey);
      } catch (error) {
        return;
      }
    }

    showDuplicateMessage() {
      if (this.$duplicateMessage) {
        this.$duplicateMessage.hidden = false;
      }
    }

    hideDuplicateMessage() {
      if (this.$duplicateMessage) {
        this.$duplicateMessage.hidden = true;
      }
    }

    showInvalidEmailMessage() {
      if (this.$invalidEmailMessage) {
        this.$invalidEmailMessage.hidden = false;
      }
    }

    hideInvalidEmailMessage() {
      if (this.$invalidEmailMessage) {
        this.$invalidEmailMessage.hidden = true;
      }
    }

    showRequiredEmailMessage() {
      if (this.$requiredEmailMessage) {
        this.$requiredEmailMessage.hidden = false;
      }
    }

    hideRequiredEmailMessage() {
      if (this.$requiredEmailMessage) {
        this.$requiredEmailMessage.hidden = true;
      }
    }

    setSubmitLoading(isLoading) {
      this.clearSubmitLoadingTimers();
      this.isSubmitting = isLoading;
      this.isSubmitPending = false;
      if (this.$submitButton) {
        this.$submitButton.dataset.loading = String(isLoading);
        this.$submitButton.setAttribute('aria-busy', String(isLoading));
      }
      if (this.$emailInput) {
        this.$emailInput.readOnly = isLoading;
      }
      this.updateSubmitButton();

      if (isLoading) {
        this.submitLoadingResetTimer = window.setTimeout(() => {
          this.setSubmitLoading(false);
        }, 10000);
      }
    }

    queueSubmitLoading(event) {
      this.isSubmitPending = true;
      this.submitLoadingDelayTimer = window.setTimeout(() => {
        this.submitLoadingDelayTimer = null;
        this.isSubmitPending = false;

        if (!event.defaultPrevented) {
          this.setSubmitLoading(true);
        }
      }, 0);
    }

    clearSubmitLoadingTimers() {
      if (this.submitLoadingDelayTimer) {
        window.clearTimeout(this.submitLoadingDelayTimer);
        this.submitLoadingDelayTimer = null;
      }
      if (this.submitLoadingResetTimer) {
        window.clearTimeout(this.submitLoadingResetTimer);
        this.submitLoadingResetTimer = null;
      }
    }

    updateSubmitButton() {
      if (this.$submitButton) {
        this.$submitButton.disabled = this.isSubmitting;
      }
    }

  }

  if (!window.customElements.get('yg-subscribe-form-v1')) {
    window.customElements.define('yg-subscribe-form-v1', YGSubscribeFormV1);
  }

  } catch(e) { console.error(e); }
})();
})();
